module.exports = __webpack_public_path__ + "img/privacy_info4.534d1051.png";